import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getPressedStyle = (Control: StyledComponent, checked: boolean): SerializedStyles => css`
  &:active {
    ${Control} {
      box-shadow: none;

      ${checked
        ? css`
            background-color: ${Color.Lavender600};
          `
        : css`
            background-color: ${Color.Grey700};
          `};
    }
  }
`
